module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fzg-chuangfu-pc"
  }, [_c('div', {
    staticClass: "fzg-banner"
  }, [_c('fzg-menu'), _vm._v(" "), _c('div', {
    staticClass: "sologan"
  })], 1), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "cf-intro"
  }, [_c('div', {
    staticClass: "cf-intro-left"
  }, [_c('div', {
    staticClass: "intro-title",
    class: {
      'intro-title-active': _vm.activeIntro == 0
    },
    on: {
      "click": function($event) {
        _vm.activeIntro = 0
      }
    }
  }, [_vm._v("ROADSHOW")]), _vm._v(" "), _c('div', {
    staticClass: "intro-title",
    class: {
      'intro-title-active': _vm.activeIntro == 1
    },
    on: {
      "click": function($event) {
        _vm.activeIntro = 1
      }
    }
  }, [_vm._v("小饭局")]), _vm._v(" "), _c('div', {
    staticClass: "intro-title",
    class: {
      'intro-title-active': _vm.activeIntro == 2
    },
    on: {
      "click": function($event) {
        _vm.activeIntro = 2
      }
    }
  }, [_vm._v("创业课堂")]), _vm._v(" "), _c('div', {
    staticClass: "intro-title",
    class: {
      'intro-title-active': _vm.activeIntro == 3
    },
    on: {
      "click": function($event) {
        _vm.activeIntro = 3
      }
    }
  }, [_vm._v("区域经济与政策支持")])]), _vm._v(" "), _c('div', {
    staticClass: "cf-intro-right"
  }, [_vm._m(1, false, false), _vm._v(" "), _c('div', {
    staticClass: "intro-content"
  }, [(_vm.activeIntro == 0) ? [_c('p', [_vm._v("小饭桌ROADSHOW是凡卓集团旗下小饭桌创服重磅推出的高质量创业项目路演活动，聚焦前沿科技与数字经济，持续挖掘产业增长引擎，帮助优质创业项目深度链接多元投资机构与区域产业资源，打造精准、高效、深度的产业交流平台。")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("依托于凡卓集团自身影响力与投融资服务的专业能力，将优质创业项目与多元投资机构深度链接。根据城市产业格局精细化定制路演项目筛选标准，匹配高效精准。")])] : _vm._e(), _vm._v(" "), (_vm.activeIntro == 1) ? [_c('p', [_vm._v("小饭局是由小饭桌打造的行业主题沙龙，聚焦新一代信息技术、新能源、新材料、先进制造、企业服务、生命科学等方向。")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("以线上研讨会、线下闭门会和饭局漫谈等多种有趣有料的交流形式为桌友提供观点交换的平台和高质量社交的场域。")])] : _vm._e(), _vm._v(" "), (_vm.activeIntro == 2) ? [_c('p', [_vm._v("龙头企业深度参访、产业及技术深度介绍及交流，实体参览；龙头企业创始人进行深度企业发展历程及行业分享；核心业务线高管从企业经营、渠道营销等维度分享实操经验；现场进行业务建议与合作探讨，快速落地合作。")])] : _vm._e(), _vm._v(" "), (_vm.activeIntro == 3) ? [_c('p', [_vm._v("深耕中国新兴产业，基于“产业深度研究+投融资大数据”，为中国产业参与者提供一揽子综合服务;面向城市管理者、产业投资者和优秀创业者，提供城市级产业战略方案、市场进入、园区规划、产业并购整合与战略咨询服务、创业企业经营布局与融资一体化解决方案、项目可行性研究、数字化转型及其他配套产业研究与解决方案。")])] : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "cf-media"
  }, [_c('img', {
    staticClass: "media-title",
    attrs: {
      "src": require("../../assets/img2/pc/chuangfu/title-media.png"),
      "alt": ""
    }
  }), _vm._v(" "), _vm._m(2, false, false), _vm._v(" "), _c('div', {
    staticClass: "media-list"
  }, [_vm._m(3, false, false), _vm._v(" "), _vm._m(4, false, false), _vm._v(" "), _c('div', {
    staticClass: "media-item",
    on: {
      "click": function($event) {
        _vm.isShowModal = true
      }
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../../assets/img2/pc/chuangfu/media-metrics.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("平台矩阵")])])]), _vm._v(" "), _vm._m(5, false, false)]), _vm._v(" "), (_vm.isShowModal) ? _c('fzg-chuang-fu-metrics-modal', {
    on: {
      "hide-modal": function($event) {
        _vm.isShowModal = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fzg-cf-business"
  }, [_c('div', {
    staticClass: "bus-wrap"
  }, [_c('div', {
    staticClass: "bus-item"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../../assets/img2/pc/chuangfu/logo2.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("创投媒体")])]), _vm._v(" "), _c('div', {
    staticClass: "bus-item"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../../assets/img2/pc/chuangfu/logo8.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("产业峰会")])]), _vm._v(" "), _c('div', {
    staticClass: "bus-item"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../../assets/img2/pc/chuangfu/logo6.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("路演论坛")])]), _vm._v(" "), _c('div', {
    staticClass: "bus-item"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../../assets/img2/pc/chuangfu/logo5.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("创投培训")])]), _vm._v(" "), _c('div', {
    staticClass: "bus-item"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../../assets/img2/pc/chuangfu/logo1.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("创业孵化")])]), _vm._v(" "), _c('div', {
    staticClass: "bus-item"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../../assets/img2/pc/chuangfu/logo3.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("产业咨询")])]), _vm._v(" "), _c('div', {
    staticClass: "bus-item"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../../assets/img2/pc/chuangfu/logo4.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("商机对接")])]), _vm._v(" "), _c('div', {
    staticClass: "bus-item"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../../assets/img2/pc/chuangfu/logo7.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("飞地运营")])]), _vm._v(" "), _c('div', {
    staticClass: "bus-item"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../../assets/img2/pc/chuangfu/logo9.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("投融资数据库")])]), _vm._v(" "), _c('div', {
    staticClass: "bus-item"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../../assets/img2/pc/chuangfu/logo10.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("人才对接")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "intro-title"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img2/pc/chuangfu/title-business.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "media-intro"
  }, [_vm._v("\n      小饭桌公众号拥有 "), _c('span', {
    staticClass: "num"
  }, [_vm._v("30万+")]), _vm._v(" 高净值粉丝，"), _c('span', {
    staticClass: "num"
  }, [_vm._v("100%")]), _vm._v(" 覆盖一线投资机构 "), _c('br'), _vm._v("\n      内容全网曝光量累计 "), _c('span', {
    staticClass: "num"
  }, [_vm._v("1亿+")]), _vm._v("，超过 "), _c('span', {
    staticClass: "num"
  }, [_vm._v("2000+")]), _vm._v(" 企业通过小饭桌创服媒体的报道成功获得融资\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "media-item"
  }, [_c('div', {
    staticClass: "wechat-code"
  }, [_c('img', {
    attrs: {
      "src": "https://www.xfz.cn/static/build/images/xfz-wechat-share.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wechat-name"
  }, [_vm._v("小饭桌公众号")])]), _vm._v(" "), _c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../../assets/img2/pc/chuangfu/media-wechat.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("公众号")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "media-item"
  }, [_c('a', {
    attrs: {
      "href": "https://xfz.cn",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../../assets/img2/pc/chuangfu/media-pc.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("门户网站")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "media-other"
  }, [_c('a', {
    staticClass: "item",
    attrs: {
      "href": "https://mp.weixin.qq.com/mp/appmsgalbum?__biz=MzA3OTMxMDUzOQ==&action=getalbum&album_id=2850012663396220928",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img2/pc/chuangfu/card-tzrs.jpg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "item",
    attrs: {
      "href": "https://mp.weixin.qq.com/mp/appmsgalbum?__biz=MzA3OTMxMDUzOQ==&action=getalbum&album_id=1332421567602851841&scene=126#wechat_redirect",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img2/pc/chuangfu/card-cyzs.jpg"),
      "alt": ""
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a7dee386"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/service/FzgChuangFuPc.vue
// module id = 238
// module chunks = 0